import { FormElement } from '../../form-element.model';
import { FormElementAddressField } from './form-element-address-field.model';
import { AddressType } from 'src/app/admin/codes/shared/dto/address-type.model';

export class FormElementProfileAddress extends FormElement {
  public Address1: FormElementAddressField;
  public Address2: FormElementAddressField;
  public City: FormElementAddressField;
  public State: FormElementAddressField;
  public Zip: FormElementAddressField;
  public ZipExt: FormElementAddressField;
  public County: FormElementAddressField;
  public Country: FormElementAddressField;
  public AddressTypeId: number;
  public AddressType: AddressType;

  public constructor() {
    super();

    this.initialize();
  }

  public initialize(): void {
    this.ElementTypeId = 13;

    this.Address1 = new FormElementAddressField();
    this.Address2 = new FormElementAddressField();
    this.City = new FormElementAddressField();
    this.State = new FormElementAddressField();
    this.Zip = new FormElementAddressField();
    this.ZipExt = new FormElementAddressField();
    this.County = new FormElementAddressField();
    this.Country = new FormElementAddressField();

    this.Address1.LabelText = 'Address 1';
    this.Address1.Visible = true;

    this.Address2.LabelText = 'Address 2';
    this.Address2.Visible = true;

    this.City.LabelText = 'City';
    this.City.Visible = true;

    this.State.LabelText = 'State';
    this.State.Visible = true;

    this.Zip.LabelText = 'Zip';
    this.Zip.Visible = true;

    this.ZipExt.LabelText = 'Zip Ext';
    this.County.LabelText = 'County';
    this.Country.LabelText = 'Country';
    this.AddressTypeId = 0;
    this.AddressType = new AddressType();
  }
}
